import { render, staticRenderFns } from "./report-svod-doh.vue?vue&type=template&id=0be195f9&scoped=true&"
import script from "./report-svod-doh.vue?vue&type=script&lang=ts&"
export * from "./report-svod-doh.vue?vue&type=script&lang=ts&"
import style0 from "./report-svod-doh.vue?vue&type=style&index=0&id=0be195f9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be195f9",
  null
  
)

export default component.exports